var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{attrs:{"message":_vm.message},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('div',{class:_vm.$style.markdown,domProps:{"innerHTML":_vm._s(_vm.markdown)}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }